import { React } from 'react';
import SubscriptionBadge from '../../../elements/SubscriptionBadge';

import "./styles.scss";

export const InteractivePanel = (props) => {
    const {
        icon,
        headerText,
        descriptionText,
        available,
        clickFunction,
        showSubscriptionBadge = false,
        requiredPlan = "Advanced",
    } = props;

    const handleClick = () => {
        if (available) {
            clickFunction?.();
        }
    };

    return(
        <div className={`panel-button-container ${!available ? "disabled" : ""}`} onClick={handleClick}>
            <div className="panel-button-icon">{icon}</div>
            <div className="panel-button-text">
                <div className="panel-button-header">
                    {headerText}
                </div>
                <div className="panel-button-desc">{descriptionText}</div>
            </div>
            {showSubscriptionBadge && !available && (
                <div 
                    className="panel-button-badge"
                    onClick={(e) => e.stopPropagation()}
                >
                    <SubscriptionBadge 
                        isAvailable={available} 
                        requiredPlan={requiredPlan}
                    />
                </div>
            )}
        </div>
    );
};
